import script from "./Template.vue?vue&type=script&setup=true&lang=js"
export * from "./Template.vue?vue&type=script&setup=true&lang=js"

import "./Template.vue?vue&type=style&index=0&id=591c5230&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-591c5230"]])

export default __exports__